import constants from '../BirthdayModule.constants';

export const getChildrenAction = (payload) => ({
  type: constants.GET_CHILDREN,
  payload,
});
export const setBirthdayChildrenHp = (payload) => {
  return {
    type: constants.SET_CHILDREN,
    payload,
  };
};
export const resetBirthdayModule = () => ({
  type: constants.CLEAR_BIRTHDAY_MODULE,
});
export const setCD81 = (payload) => {
  return {
    type: constants.SET_CD81,
    payload,
  };
};
export const clearCD81 = () => {
  return {
    type: constants.CLEAR_CD81,
  };
};
